(() => {
  if (window.LsGuides) return;

  const readJSON = (root, selector) => {
    const node = root.querySelector(selector);
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  };
  const fill = (template, vars) =>
    String(template || '').replace(/\{(\w+)\}/g, (match, key) => (key in vars ? vars[key] : match));

  function library(root) {
    if (root.dataset.lsReady) return;
    root.dataset.lsReady = '1';
    const T = readJSON(root, '[data-ls-guides-library-config]');
    const cards = [...root.querySelectorAll('[data-guide-card]')];
    const search = root.querySelector('[data-guide-search]');
    const buttons = [...root.querySelectorAll('.bg-filter')];
    const count = root.querySelector('[data-guide-count]');
    const none = root.querySelector('[data-guide-none]');
    const initialCount = count ? count.textContent : '';
    let category = '';
    root.querySelectorAll('[data-library-tools]').forEach((node) => (node.hidden = false));

    const params = new URLSearchParams(location.search);
    const wanted = params.get('category');
    if (wanted && buttons.some((b) => b.dataset.category === wanted)) category = wanted;

    const apply = () => {
      const words = (search ? search.value : '').trim().toLowerCase().split(/\s+/).filter(Boolean);
      let shown = 0;
      cards.forEach((card) => {
        const match =
          (!category || card.dataset.category === category) &&
          words.every((word) => card.dataset.search.includes(word));
        card.hidden = !match;
        if (match) shown += 1;
      });
      buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.category === category)));
      if (count) {
        const filtered = category || words.length;
        count.textContent = !filtered ? initialCount : shown === 1 ? T.one : fill(T.filtered, { count: shown });
      }
      if (none) none.hidden = shown > 0;
    };

    buttons.forEach((b) =>
      b.addEventListener('click', () => {
        category = b.dataset.category;
        const url = new URL(location.href);
        if (category) url.searchParams.set('category', category);
        else url.searchParams.delete('category');
        history.replaceState(history.state, '', url);
        apply();
      })
    );
    if (search) search.addEventListener('input', apply);
    apply();
  }

  function shortlist(root) {
    if (root.dataset.lsReady) return;
    root.dataset.lsReady = '1';
    const T = readJSON(root, '[data-shortlist-config]');
    const results = root.querySelector('[data-product-results]');
    const items = [...root.querySelectorAll('[data-guide-product]')];
    const count = root.querySelector('[data-product-count]');
    const empty = root.querySelector('[data-no-results]');
    const moreRow = root.querySelector('[data-more-row]');
    const more = root.querySelector('[data-more-products]');
    const filters = root.querySelector('[data-filters]');
    const field = (name) => root.querySelector(`[data-filter="${name}"]`);
    const step = Number(root.dataset.initial) || 6;
    let limit = step;
    if (filters) filters.hidden = false;

    const apply = () => {
      const band = field('band') ? field('band').value : '';
      const sound = field('sound') ? field('sound').value : '';
      const sort = field('sort') ? field('sort').value : '';
      const words = (field('query') ? field('query').value : '').trim().toLowerCase().split(/\s+/).filter(Boolean);
      const [min, max] = band ? band.split('-').map(Number) : [0, Infinity];
      const matches = items.filter((item) => {
        const price = Number(item.dataset.price) / 100;
        return (
          (!band || (price >= min && price < max)) &&
          (!sound || item.dataset.sound.split(' ').includes(sound)) &&
          words.every((word) => item.dataset.search.includes(word))
        );
      });
      const order = [...matches].sort((a, b) => {
        if (sort === 'price-low') return a.dataset.price - b.dataset.price;
        if (sort === 'price-high') return b.dataset.price - a.dataset.price;
        if (sort === 'name') return a.dataset.name.localeCompare(b.dataset.name);
        return a.dataset.index - b.dataset.index;
      });
      items.forEach((item) => (item.hidden = true));
      order.forEach((item, i) => {
        results.insertBefore(item, empty);
        item.hidden = i >= limit;
      });
      if (moreRow) moreRow.hidden = order.length <= limit;
      if (empty) empty.hidden = order.length > 0 || items.length === 0;
      if (count && items.length) {
        const filtered = band || sound || words.length;
        count.textContent = filtered
          ? fill(T.filtered, { shown: order.length, count: items.length })
          : items.length === 1
            ? T.one
            : fill(T.count, { count: items.length });
      }
    };

    root.querySelectorAll('[data-filter]').forEach((node) =>
      node.addEventListener(node.tagName === 'INPUT' ? 'input' : 'change', () => {
        limit = step;
        apply();
      })
    );
    const clear = root.querySelector('[data-clear-filters]');
    if (clear)
      clear.addEventListener('click', () => {
        root.querySelectorAll('[data-filter]').forEach((node) => (node.value = ''));
        limit = step;
        apply();
      });
    if (more)
      more.addEventListener('click', () => {
        const firstHidden = items.find((item) => item.hidden && item.parentNode);
        limit += step;
        apply();
        if (firstHidden && !firstHidden.hidden) firstHidden.querySelector('a.bg-action')?.focus();
      });
    apply();
  }

  function viewer(root) {
    const dialog = root.querySelector('[data-guide-dialog]');
    if (!dialog || dialog.dataset.lsReady) return;
    dialog.dataset.lsReady = '1';
    const T = readJSON(dialog, '[data-dialog-config]');
    const image = dialog.querySelector('[data-dialog-image]');
    const title = dialog.querySelector('[data-dialog-title]');
    const position = dialog.querySelector('[data-dialog-count]');
    let list = [];
    let index = 0;
    let opener = null;

    const show = () => {
      image.src = list[index];
      image.alt = fill(T.alt || '{title}', { title: title.textContent });
      position.textContent = fill(T.count, { n: index + 1, total: list.length });
      dialog.querySelectorAll('[data-dialog-prev],[data-dialog-next]').forEach((b) => (b.hidden = list.length < 2));
    };
    const go = (delta) => {
      index = (index + delta + list.length) % list.length;
      show();
    };

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-guide-gallery]');
      if (!trigger) return;
      try {
        list = JSON.parse(trigger.dataset.guideGallery);
      } catch (error) {
        list = [];
      }
      if (!list.length) return;
      index = Number(trigger.dataset.imageIndex) || 0;
      title.textContent = trigger.dataset.galleryTitle || '';
      opener = trigger;
      show();
      dialog.showModal();
    });
    dialog.querySelector('[data-dialog-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-dialog-prev]').addEventListener('click', () => go(-1));
    dialog.querySelector('[data-dialog-next]').addEventListener('click', () => go(1));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') go(-1);
      if (event.key === 'ArrowRight') go(1);
    });
    dialog.addEventListener('close', () => {
      if (opener) opener.focus();
    });
  }

  function boot(scope = document) {
    scope.querySelectorAll('[data-ls-guides-library]').forEach(library);
    scope.querySelectorAll('[data-guide-shortlist]').forEach(shortlist);
    scope.querySelectorAll('[data-ls-guide-article]').forEach(viewer);
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-guide-budget][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest && event.target.closest('[data-guide-budget][open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary').focus();
  });

  window.LsGuides = { boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
